module.exports = __webpack_public_path__ + "img/2.69d71ae4.webp";